"use strict";
declare var global: any;

import * as React from "react"
import * as ReactDOM from "react-dom"

import { useAnnouncementsService } from "./AnnouncementsService"

interface AnnouncementsProps {
    serviceUrl: string;
}

export const AnnouncementsWrapper = (props: AnnouncementsProps) => {
    const announcementsService = useAnnouncementsService(props.serviceUrl);

    return (
        <Announcements announcementsService={announcementsService} />
    );
};

export class Announcements extends React.Component {
    props: any;
    state: AnnouncementsState;

    constructor(props: any) {
        super(props);

        this.state = {
            Announcements: null,
            loaded: false
        };

        this.loadSucceeded = this.loadSucceeded.bind(this);
        this.loadFailed = this.loadFailed.bind(this);
    }

    componentDidMount = function () {
        this.props.announcementsService.getAnnouncements().then(this.loadSucceeded).catch(this.loadFailed);
    };

    loadSucceeded = function (announcements: any) {
        this.setState({ Announcements: announcements, loaded: true });
    };

    loadFailed = function () {
        this.setState({ loaded: true });
    }

    render() {
        if (this.state.Announcements === null || this.state.Announcements.length === 0) {
            return null;
        }

        const announcements = this.state.Announcements.map((a, i) =>
            <Announcement from={a.from} subject={a.subject} body={a.body} type={a.type} key={i} index={i}/>
        );

        return <div>
            {announcements}
        </div>
    }
}

interface AnnouncementProps {
    from: string;
    subject: string;
    body: string;
    type: number;
    key: number;
    index: number;
}

interface AnnouncementsState {
    Announcements: Array<any>;
    loaded: boolean;
}

export class Announcement extends React.Component {
    props: AnnouncementProps;

    constructor(props: AnnouncementProps) {
        super(props);
    }  

    render() {
        let typeClass = "";
        switch (this.props.type) {
            case 1: //Error
                typeClass = " alert-plain alert-danger";
                break;
            case 2: //Warning
                typeClass = " alert-plain alert-warning";
                break;
            case 3: //Info
                typeClass = " alert-plain alert-info";
                break;
            case 4: //Verbose
                typeClass = " alert-plain";
                break;
        }

        return <div>
            {(this.props.index > 0) &&
                <h4 />
            }
            <div className={'form-horizontal' + typeClass}>
                <h3>{this.props.from && <span>{this.props.from}: </span>}{this.props.subject}</h3>
                <div dangerouslySetInnerHTML={{ __html: this.props.body }}></div>
            </div>
        </div>
    }
}

const _global = (window /* browser */ || global /* node */) as any
_global.showAnnouncements = (containerId: string, serviceUrl: string) => {
    ReactDOM.render(<AnnouncementsWrapper serviceUrl={serviceUrl} />, document.getElementById(containerId));
}